import { render, staticRenderFns } from "./ConclusionModal.vue?vue&type=template&id=315c6f10"
import script from "./ConclusionModal.vue?vue&type=script&lang=js"
export * from "./ConclusionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports